import { CreateFundingDetailsReduxState, FundingDetailsReducerDispatch, FundingDetailsReduxTypes } from "./types"

const CREATE_FUNDING_DETAILS_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateFundingDetailsReducer = (state: CreateFundingDetailsReduxState = CREATE_FUNDING_DETAILS_INIT_STATE, action: FundingDetailsReducerDispatch) => {
    switch (action.type) {
        case FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT:
            return {
                ...state,
                loading: true
            }
        case FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        case FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        default:
            return { ...state };
    }
}

export { CreateFundingDetailsReducer }